// extracted by mini-css-extract-plugin
export default {"modalContent":"styles_modalContent__Y0Fmx","modalOverlay":"styles_modalOverlay__b3gMd"};